import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  typography: {
    fontFamily: "SF Pro Text, SF-Pro-Text, Segoe UI, Arial, sans-serif",
  },
  components: {
    MuiAutocomplete: {
      styleOverrides: {
        option: {
          fontSize: "16px",
          padding: "10px 16px",
          color: "#1f1f1f",
          marginLeft: "8px",
          marginRight: "8px",
          borderRadius: "8px",
          '&[aria-selected="true"]': {
            backgroundColor: "transparent",
            color: "#6d65ed",
          },
          '&[aria-selected="true"]:hover': {
            backgroundColor: "#F9FAFB",
          },
          "&:hover": {
            backgroundColor: "#F9FAFB",
          },
        },
        listbox: {
          maxHeight: 300,
          overflowY: 'auto',
        },
        paper: {
          maxHeight: 'none',
          boxShadow: '0px 2px 4px -1px #0000000F, 0px 4px 6px -1px #0000001A',
          border: '1px solid #E4E4E7',
          borderRadius: '8px',
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontSize: "16px",
          color: "#1f1f1f",
          padding: "10px 16px",
          marginLeft: "8px",
          marginRight: "8px",
          borderRadius: "8px",
          '&.Mui-selected': {
            color: '#6D65ED',
            backgroundColor: 'transparent',
          },
          '&.Mui-selected:hover': {
            backgroundColor: '#F1F2F3',
          },
          '&:hover': {
            backgroundColor: '#F1F2F3',
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          '&.Mui-selected, &[aria-selected="true"]': {
            color: '#6D65ED',
          },
          borderRadius: '8px',
        },
        root: {
          borderRadius: '8px',
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
        },
        input: {
          '&.Mui-selected, &[aria-selected="true"]': {
            color: '#6D65ED',
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#E4E4E7',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderWidth: '1px !important',
            borderColor: '#E4E4E7',
          },
          borderRadius: '8px',
        },
        notchedOutline: {
          borderWidth: '1px',
          borderColor: '#E4E4E7',
          borderRadius: '8px',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#E4E4E7',
          },
          '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderWidth: '1px !important',
            borderColor: '#E4E4E7',
          },
          borderRadius: '8px',
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        track: {
          backgroundColor: '#E5E7EB',
          opacity: 1,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          boxShadow: '0px 2px 4px -1px #0000000F, 0px 4px 6px -1px #0000001A',
          border: '1px solid #E4E4E7',
          borderRadius: '8px',
        },
      },
    },
    // ...other shared theme customizations as in your reference
  },
});
